import { Icon, MarketIconSymbol, Typography } from "@kyan/ui";

import { defaultUnderlying } from "#/config/markets";

import { useZeroTradingFeesSlideController } from "./ZeroTradingFees.controller";

export const ZeroTradingFeesSlide = () => {
  const { instrumentName } = useZeroTradingFeesSlideController();

  return (
    <div className="flex h-54 flex-col items-center gap-2">
      <Typography
        bold
        grotesk
        className="h-28 bg-[linear-gradient(157deg,#3550FC_25.62%,#203096_128.54%)] bg-clip-text text-9xl text-transparent"
      >
        0%
      </Typography>

      <div className="border-divider flex min-w-55 flex-col items-start rounded-lg border p-2">
        <div className="flex items-center justify-center gap-2">
          <Icon
            size="md"
            name={defaultUnderlying.toLowerCase() as MarketIconSymbol}
            className="rounded-sm bg-[linear-gradient(90deg,#3550FC_0%,#203096_100%)] px-3 py-1.5 text-white"
          />
          <div className="flex flex-col">
            <Typography primary>{instrumentName}</Typography>
            <Typography size={11}>Best Ask $703</Typography>
          </div>
        </div>
      </div>

      <Typography>Trade with zero fees</Typography>
    </div>
  );
};
